var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFuncioanlModo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 81,
    viewBox: "0 0 73 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1228"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 673"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 34",
    d: "M11.8936 8.16406H34.8188H36.2516M11.8936 15.3282H27.6547",
    stroke: "#9497A4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 35",
    d: "M11.8936 1H34.8188H36.2516",
    stroke: "#9497A4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 671"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line 209",
    x1: 36.4365,
    y1: 8.51367,
    x2: 36.4365,
    y2: 79.8893,
    stroke: "#9497A4",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 37",
    d: "M1 80.2648C18.6561 62.6088 22.4127 14.1484 35.9365 14.1484C49.4603 14.1484 52.4656 60.3548 72 80.2648",
    stroke: "#9497A4",
    strokeDasharray: "2 2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.6152 32.1321H48.2586V39.4512L58.1159 29.6924L48.2586 19.9336V27.2527H18.6865V41.8909H23.6152V32.1321ZM48.2586 56.529H23.6152V49.2099L13.7578 58.9687L23.6152 68.7275V61.4084H53.1872V46.7702H48.2586V56.529Z",
    fill: "#00D084"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuncioanlModo);
export default __webpack_public_path__ + "static/media/funcioanl_modo.68bec26895a29acae2dc78f42b195e79.svg";
export { ForwardRef as ReactComponent };